import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; 
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

/**
 * ✅ نظام التحديث الصامت والذكي (Silent Update)
 * تم حذف الـ alert لضمان تجربة مستخدم سلسة واحترافية.
 * عند توفر نسخة جديدة، يتم تحديثها في الخلفية وإعادة تنشيط الصفحة تلقائياً.
 */
serviceWorkerRegistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      // 1. إرسال أمر لتجاوز الانتظار وتفعيل النسخة الجديدة فوراً
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
      
      // 2. الاستماع لتغير الحالة؛ بمجرد التفعيل يتم عمل Reload صامت
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
    }
  },
  onSuccess: () => {
    console.log("نظام PWA يعمل بنجاح 🚀 المنصة جاهزة للعمل أوفلاين.");
  },
});